


























































import Vue from 'vue'
import CDropdownMenu from '~/components/shared/configurable/dropdown/CDropdownMenu.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CDropdownMenuItem from '~/components/shared/configurable/dropdown/CDropdownMenuItem.vue'
import { mapState } from 'vuex'
import Breadcrumbs from '~/components/car/Breadcrumbs.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import VueI18n from 'vue-i18n'

type PageType = {
  path: string
  nuxtLink?: boolean
  label?: VueI18n.TranslateResult
  showForUserType: string
  children?: {
    label: VueI18n.TranslateResult
    path: string
    nuxtLink: boolean
  }[]
}

export default Vue.extend({
  components: {
    Breadcrumbs, // TODO: Verify usage. Not being hydrated locally.
    CDropdownMenu,
    CLink,
    CDropdownMenuItem,
    CCard
  },
  data() {
    return {
      selectedTab: this.$router.resolve({
        name: this.$route.name ? this.$route.name : undefined
      }).href,
      breadcrumb: [
        {
          url: '/information/contact',
          text: this.$t('information'),
          icon: null
        },
        {
          url: '/information/contact',
          text: this.$t('contact'),
          icon: null
        }
      ],
      pages: [
        {
          path: '/information/contact',
          nuxtLink: true,
          label: this.$i18n.t('contact'),
          showForUserType: 'all'
        },
        {
          path: '/dealers/register/',
          nuxtLink: false,
          label: this.$i18n.t('dealer registration'),
          showForUserType: 'all'
        },
        {
          path: '/cartalog/register/',
          nuxtLink: false,
          label: this.$i18n.t('register your business'),
          showForUserType: 'all'
        },
        {
          path: '/information/simboulos',
          nuxtLink: true,
          label: this.$i18n.t('market guide'),
          showForUserType: 'all'
        },
        {
          path: '/information/renew',
          nuxtLink: false,
          label: this.$i18n.t('subscription renewal'),
          showForUserType: 'Manager'
        },
        {
          label: this.$i18n.t('frequently asked questions'),
          children: [
            {
              label: this.$i18n.t('users faq'),
              path: '/information/users_faq',
              nuxtLink: true
            },
            {
              label: this.$i18n.t('dealers faq'),
              path: '/information/dealers_faq',
              nuxtLink: true
            }
          ],
          showForUserType: 'all'
        },
        {
          label: this.$i18n.t('job offers'),
          nuxtLink: true,
          path: '/information/careers',
          showForUserType: 'all'
        },
        {
          label: this.$i18n.t('terms and conditions'),
          nuxtLink: true,
          path: '/information/terms',
          showForUserType: 'all'
        },
        {
          label: this.$i18n.t('privacy policy'),
          nuxtLink: true,
          path: '/information/privacy',
          showForUserType: 'all'
        }
      ]
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userType: 'type'
    }),
    breadcrumbs() {
      const [infoBC] = this.breadcrumb
      const activePages = this.pages
        .filter(p =>
          p.children
            ? p.children.find(c => c.path === this.selectedTab)
            : p.path === this.selectedTab
        )
        .map(item => {
          if (item.children) {
            const activeChild = item.children.find(
              c => c.path === this.selectedTab
            ) as { path: string; label: VueI18n.TranslateResult }
            const { path, label } = activeChild
            return {
              url: path,
              text: label || '',
              icon: null
            }
          }
          return { url: item.path, text: item.label || '', icon: null }
        })
      const newBreadcrumb = [infoBC, ...activePages]
      return newBreadcrumb
    }
  },
  updated() {
    this.selectedTab = this.$route.path
  },

  methods: {
    dropdownActive(page: PageType) {
      return page.children?.some(
        child => child.path === this.$router.currentRoute.path
      )
    }
  }
})
